const ENV_LOCAL = 'LOCAL';
const ENV_INT = 'INT';
const ENV_PPROD = 'PPROD';
const ENV_PROD = 'PROD';

const MARKET_ECE = 'ECE';
const MARKET_CN = 'CN';
const MARKET_AMAP = 'AMAP';

export const API_URL = {
  API_URL_LOCAL: 'https://local',
  API_URL_NONPROD_ECE: 'https://mapupdate-ece-nonprod.mercedes-benz.com',
  API_URL_NONPROD_AMAP: 'https://mapupdate-amap-nonprod.mercedes-benz.com',
  API_URL_NONPROD_CN: 'https://mapupdate-cn-nonprod.mercedes-benz.com.cn',
  API_URL_PROD_ECE: 'https://mapupdate-ece.mercedes-benz.com',
  API_URL_PROD_AMAP: 'https://mapupdate-amap.mercedes-benz.com',
  API_URL_PROD_CN: 'https://mapupdate-cn.mercedes-benz.com.cn',
};

export function calculateBaseUrl(country, env) {
  if (!String.prototype.includes) {
    String.prototype.includes = function (str) {
      return this.indexOf(str) !== -1;
    };
  }
  const market = getMARKET(country);
  return mapToUrl(env, market);
}

function getMARKET(country) {
  if (
    /(AT|BE|BG|CH|CY|CZ|DE|DK|EE|ES|FI|FR|GB|GR|HR|HU|IE|IN|IT|LI|LT|LU|LV|MT|MU|NL|NO|PL|PT|RO|RU|SE|SI|SK|TH|TR|XA|XD|ZA|AE-AZ|AE-DU)/.test(
      country,
    )
  ) {
    return MARKET_ECE;
  }

  if (/(CN|HK|MO)/.test(country)) {
    return MARKET_CN;
  }

  if (/(AR|AU|BR|CA|CL|CO|JP|KR|MX|MY|NZ|SG|TW|US)/.test(country)) {
    return MARKET_AMAP;
  }

  return undefined;
}

function mapToUrl(env, market) {
  if (env === undefined) {
    return undefined;
  }
  if (env === ENV_INT && market === MARKET_ECE) {
    return API_URL.API_URL_NONPROD_ECE;
  }
  if (env === ENV_INT && market === MARKET_AMAP) {
    return API_URL.API_URL_NONPROD_AMAP;
  }
  if (env === ENV_INT && market === MARKET_CN) {
    return API_URL.API_URL_NONPROD_CN;
  }
  if (env === ENV_PPROD && market === MARKET_ECE) {
    return API_URL.API_URL_NONPROD_ECE;
  }
  if (env === ENV_PPROD && market === MARKET_AMAP) {
    return API_URL.API_URL_NONPROD_AMAP;
  }
  if (env === ENV_PPROD && market === MARKET_CN) {
    return API_URL.API_URL_NONPROD_CN;
  }
  if (env === ENV_PROD && market === MARKET_ECE) {
    return API_URL.API_URL_PROD_ECE;
  }
  if (env === ENV_PROD && market === MARKET_AMAP) {
    return API_URL.API_URL_PROD_AMAP;
  }
  if (env === ENV_PROD && market === MARKET_CN) {
    return API_URL.API_URL_PROD_CN;
  }
  if (env === ENV_LOCAL && market === MARKET_ECE) {
    return API_URL.API_URL_LOCAL;
  }
  return undefined;
}
